import request from '@/utils/request'

export function login(username, password, certificate) {
  return request({
    url: '/api/login',
    method: 'post',
    data: {
      username,
      password,
      certificate
    },
    headers: {
      Authorization: ''
    }
  })
}

export function getInfo(token, Version) {
  return request({
    url: '/api/userinfo',
    method: 'get',
    params: { token, Version }
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}
// 开启/关闭2FA接口
export function postEnabling2FA({ certificate, state, uid }) {
  return request.post(`/api/company/user/${uid}/enabling2fa/`, { certificate, state })
}
// 登录记录接口
export function getLogined({ uid, page, limit }) {
  return request.get(`/api/company/user/${uid}/logined/`, { params: { page, limit } })
}
// 发送邮箱验证码(包含邮箱验证)
export function postSendEmailCode(params) {
  return request.post(`/api/email/send`, params)
}

// 验证邮箱
export function postVerifyEmail(params) {
  return request.post(`/api/email/verify`, params)
}
// 忘记密码-重设密码
export function postUserRetrieve(params) {
  return request.post(`/api/user/retrieve`, params)
}

export function postSwitchLanguage(params) {
  return request.get(`/api/user/switch/language`, { params })
}

export function getSSOUrl() {
  return request.get('/api/saml/sso/init')
}

export function getSSOUrlGeneric(params) {
  return request.get('/api/generic/sso/info', { params })
}



// WEBPACK FOOTER //
// ./src/api/login.js